import S from "sanctuary";
import { createSelector } from "reselect";
import { getUserTimezone } from "@/components/currentUser/CurrentUser.state";
import { getClientMeta } from "@/state/client.state";

export const SET_CURRENT_PAGE = "customerSearch/SET_CURRENT_PAGE";
export const setCurrentPage = ({ pageNumber }) => ({
  type: SET_CURRENT_PAGE,
  payload: { pageNumber },
});

export const PAGE_NEXT = "customerSearch/PAGE_NEXT";
export const pageNext = () => ({
  type: PAGE_NEXT,
});

export const PAGE_PREVIOUS = "customerSearch/PAGE_PREVIOUS";
export const pagePrevious = () => ({
  type: PAGE_PREVIOUS,
});

export const SEARCH_REQUEST_PENDING = "customerSearch/SEARCH_REQUEST_PENDING";
export const setSearchRequestPending = () => ({
  type: SEARCH_REQUEST_PENDING,
});

export const SEARCH_REQUEST_FAILED = "customerSearch/SEARCH_REQUEST_FAILED";
export const setSearchRequestFailed = ({ error }) => ({
  type: SEARCH_REQUEST_FAILED,
  error: true,
  payload: error,
});

export const SEARCH_REQUEST_SUCCEEDED = "customerSearch/SEARCH_REQUEST_SUCCEEDED";
export const setSearchRequestSucceeded = () => ({
  type: SEARCH_REQUEST_SUCCEEDED,
});

export const SEARCH_REQUESTED = "customerSearch/SEARCH_REQUESTED";
export const setSearchRequested = (payload) => ({
  type: SEARCH_REQUESTED,
  payload,
});

export const PERFORM_SEARCH = "customerSearch/PERFORM_SEARCH";
export const performSearch = () => ({
  type: PERFORM_SEARCH,
});

export const REQUEST_SEARCH = "customerSearch/REQUEST_SEARCH";
export const requestSearch = () => ({
  type: REQUEST_SEARCH,
});

export const REQUEST_PAGINATED_SEARCH = "customerSearch/REQUEST_PAGINATED_SEARCH";
export const requestPaginatedSearch = ({ page }) => ({
  type: REQUEST_PAGINATED_SEARCH,
  payload: { page },
});

export const SET_CUSTOMER_SEARCH_RESULTS =
  "customerSearch/SET_CUSTOMER_SEARCH_RESULTS";
export const setCustomerSearchResults = ({ customers, customersMeta, page }) => ({
  type: SET_CUSTOMER_SEARCH_RESULTS,
  payload: {
    customers,
    customersMeta,
    page,
  },
});

export const SET_CUSTOMER_PENDING_ERROR =
  "customerSearch/SET_CUSTOMER_PENDING_ERROR";
export const setCustomerPendingError = () => ({
  type: SET_CUSTOMER_PENDING_ERROR,
});

export const REMOVE_CUSTOMER_PENDING_ERROR =
  "customerSearch/REMOVE_CUSTOMER_PENDING_ERROR";
export const removeCustomerPendingError = () => ({
  type: REMOVE_CUSTOMER_PENDING_ERROR,
});

const INITIAL_STATE = {
  searchRequestPending: false,
  searchRequested: false,
  searchRequestError: S.Nothing,
  searchCriteria: S.Nothing,
  customers: S.Just([]),
  totalSearchResultsCount: 0,
  searchResultsPageCount: 1,
  currentPage: 1,
  showCustomerPendingError: false,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_REQUEST_PENDING:
      return {
        ...state,
        searchRequestPending: true,
      };
    case SEARCH_REQUEST_FAILED:
      return {
        ...state,
        searchRequestPending: false,
        searchRequestError: S.Just(payload),
      };
    case SEARCH_REQUEST_SUCCEEDED:
      return {
        ...state,
        searchRequestPending: false,
        searchRequestError: S.Nothing,
      };
    case SEARCH_REQUESTED:
      return {
        ...state,
        searchRequested: payload,
      };
    case SET_CUSTOMER_SEARCH_RESULTS:
      return {
        ...state,
        customers: S.Just(payload.customers),
        totalSearchResultsCount: payload.customersMeta.totalResults.value,
        searchResultsPageCount: payload.customersMeta.totalPages.value,
        currentPage: payload.page,
      };
    case PAGE_NEXT:
      return {
        ...state,
        currentPage: S.clamp(1)(state.searchResultsPageCount)(state.currentPage + 1),
      };
    case PAGE_PREVIOUS:
      return {
        ...state,
        currentPage: S.clamp(1)(state.searchResultsPageCount)(state.currentPage - 1),
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: S.clamp(1)(state.searchResultsPageCount)(payload.pageNumber),
      };
    case SET_CUSTOMER_PENDING_ERROR:
      return {
        ...state,
        showCustomerPendingError: true,
      };
    case REMOVE_CUSTOMER_PENDING_ERROR:
      return {
        ...state,
        showCustomerPendingError: false,
      };
    default:
      return state;
  }
};

export const getCustomerSearchState = (state) => state.customerSearch;
export const getCriteriaFormState = (state) =>
  state.customerSearch.forms.criteriaForm;
export const getCurrentPage = (state) => state.customerSearch.currentPage;
export const getCurrentCriteria = createSelector(
  getCriteriaFormState,
  (customerSearchCriteria) =>
    Object.entries(customerSearchCriteria).reduce(
      (values, [field, value]) => ({
        ...values,
        [field]: value.rawValue,
      }),
      {}
    )
);

export const mapStateToProps = (state) => ({
  ...getCustomerSearchState(state),
  userTimezone: getUserTimezone(state),
  searchParams: getCriteriaFormState(state),
  clientMeta: getClientMeta(state),
});

export const mapDispatchToProps = (dispatch) => ({
  requestSearch: () => dispatch(requestSearch()),
  setSearchRequestPending: () => dispatch(setSearchRequestPending()),
  setSearchRequested: (payload) => dispatch(setSearchRequested(payload)),
  setSearchRequestFailed: (payload) => dispatch(setSearchRequestFailed(payload)),
  setSearchRequestSucceeded: () => dispatch(setSearchRequestSucceeded()),
  pagePrevious: () => dispatch(pagePrevious()),
  pageNext: () => dispatch(pageNext()),
  setCurrentPage: (payload) => dispatch(setCurrentPage(payload)),
  setCustomerPendingError: () => dispatch(setCustomerPendingError()),
  removeCustomerPendingError: () => dispatch(removeCustomerPendingError()),
});
export default reducer;
